import { create } from 'zustand';
import type { Header } from '@/types/header';
import { informationService, UpdateHeaderFormData, UpdateFooterDto } from '@/services/informationService';

interface InformationStore {
    information: Header | null;
    loading: boolean;
    error: string | null;

    // Actions
    fetchInformation: () => Promise<void>;
    updateInformation: (data: UpdateHeaderFormData) => Promise<void>;
    fetchFooter: () => Promise<any>;
    updateFooter: (data: UpdateFooterDto) => Promise<void>;
    setInformation: (information: Header) => void;
    setLoading: (loading: boolean) => void;
    setError: (error: string | null) => void;
    clearError: () => void;
}

export const useInformationStore = create<InformationStore>((set) => ({
    information: null,
    loading: false,
    error: null,

    fetchInformation: async () => {
        set({ loading: true, error: null });
        try {
            const response: any = await informationService.getInformation();
            if (response.data) {
                console.log("response: ", response?.data?.data)
                set({ information: response?.data?.data?.data, loading: false });
            } else {
                throw new Error('Không thể lấy thông tin header');
            }
        } catch (error: any) {
            set({
                error: error.message || 'Lỗi khi tải thông tin header',
                loading: false
            });
        }
    },

    updateInformation: async (data: UpdateHeaderFormData) => {
        set({ loading: true, error: null });
        try {
            const response: any = await informationService.updateInformation(data);
            if (response.data) {
                // Response structure: { data: { data: { ... } } }
                const headerData = response?.data?.data?.data || response?.data?.data || response.data;
                set({ information: headerData, loading: false });
            } else {
                throw new Error('Không thể cập nhật header');
            }
        } catch (error: any) {
            set({
                error: error.message || 'Lỗi khi cập nhật header',
                loading: false
            });
            throw error;
        }
    },

    fetchFooter: async () => {
        try {
            const response: any = await informationService.getFooter();
            return response?.data?.data ?? response?.data;
        } catch (error) {
            throw error;
        }
    },

    updateFooter: async (data: UpdateFooterDto) => {
        set({ loading: true, error: null });
        try {
            const response: any = await informationService.updateFooter(data);
            set({ loading: false });
            return response?.data?.data ?? response?.data;
        } catch (error: any) {
            set({ loading: false, error: error.message || 'Lỗi khi cập nhật footer' });
            throw error;
        }
    },

    setInformation: (information: Header) => set({ information }),
    setLoading: (loading: boolean) => set({ loading }),
    setError: (error: string | null) => set({ error }),
    clearError: () => set({ error: null }),
}));
